import React from 'react';
import { Edit, Trash2 } from 'lucide-react';
import { IconButton } from '@atoms';

export interface PermissionActionButtonsProps {
  onEdit: () => void;
  onDelete: () => void;
  isDeleteDisabled?: boolean;
}

export const PermissionActionButtons: React.FC<PermissionActionButtonsProps> = ({
  onEdit,
  onDelete,
  isDeleteDisabled = false
}) => {
  return (
    <div className="flex items-center justify-end space-x-2">
      <IconButton
        icon={Edit}
        onClick={onEdit}
        variant="ghost"
        size="sm"
        className="text-primary-600 hover:text-primary-800"
        title="Edit Permission"
      />
      <IconButton
        icon={Trash2}
        onClick={onDelete}
        variant="ghost"
        size="sm"
        className="text-error-600 hover:text-error-800"
        title="Delete Permission"
        disabled={isDeleteDisabled}
      />
    </div>
  );
};
